import { UserInfo } from '../../modules/shared/interfaces/user/user-info.interface';

export interface UserState {
  userInfo: UserInfo;
}

export const initialState: UserState = {
  userInfo: null
};
